"use client"
import { Card } from "@/components/ui/card"
import Image from "next/image"

interface PortfolioImage {
  thumbSrc: string
  fullSrc: string
  alt: string
}

interface PortfolioGridProps {
  images: PortfolioImage[]
  onImageClick: (image: {src: string; alt: string}) => void
}

export function PortfolioGrid({ images, onImageClick }: PortfolioGridProps) {
  return (
    <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
      {images.map((image, index) => (
        <Card 
          key={index}
          className="break-inside-avoid overflow-hidden cursor-zoom-in group hover:shadow-2xl transition-all duration-500 border-border/40 hover:border-purple-500/50 bg-card/50 backdrop-blur-sm mb-6" 
          onClick={() => onImageClick({src: image.fullSrc, alt: image.alt})}
        >
          <div className="relative w-full overflow-hidden">
            <Image
              src={image.fullSrc || image.thumbSrc}
              alt={image.alt}
              width={1280}
              height={1280}
              className="w-full h-auto group-hover:scale-105 transition-transform duration-700 ease-out"
              sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
              priority={index < 3}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-4">
              <span className="text-white text-xs font-mono uppercase tracking-widest">{image.alt}</span>
            </div>
          </div>
        </Card>
      ))}
    </div>
  )
}
